"use client";

import React from "react";

interface VideoPlayerProps {
  src: string;
  type?: string;
  poster?: string;
  videoClassName?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  src,
  type,
  poster,
  videoClassName,
}) => {
  if (!src) return null;

  return (
    <video
      className={videoClassName}
      src={src}
      poster={poster}
      muted
      loop
      playsInline
      autoPlay
      controls={false}
    >
      {type && <source src={src} type={type} />}
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;


